// extracted by mini-css-extract-plugin
export default {"editableWrapper":"src-views-editor-components-PollLayouts-Components-EditableTitleWithGridLayout-EditableTitleWithGridLayout__editableWrapper--ubddl"};